/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type VendorApiResourceAccountStatus = typeof VendorApiResourceAccountStatus[keyof typeof VendorApiResourceAccountStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VendorApiResourceAccountStatus = {
  active: 'active',
  unconfirmed: 'unconfirmed',
  blocked: 'blocked',
} as const;
